import { buildSoftwareApplicationLd, EDGELY_PLAN_OFFERS } from "../../shared/seoJsonLd";

// Same offer set as the homepage SoftwareApplication LD (real prices).
export const FEATURE_SOFTWARE_LD = buildSoftwareApplicationLd(EDGELY_PLAN_OFFERS);
